import React from 'react';
import DsButton from '../../common/DsButton';
import EventNavigationMenu from './EventNavigationMenu';
import { ActionRowsSkeleton } from '../../common/ContentSkeletons';
import { SkeletonPill } from '../../common/Skeleton';

export default function EventDetailsResourceContractPanels({ view }) {
  const {
    EventMaterialExplorer,
    EventImageGallery,
    canEditEventInfo,
    canEditEventImages,
    canEditMaterials,
    canEditParticipants,
    canDownloadEventImages,
    canDownloadMaterials,
    canViewContractStatus,
    canViewEventImages,
    canViewMaterials,
    canViewParticipants,
    cancelCompLoading,
    cancelCompSaving,
    contractStatusSummary,
    contractTableRows,
    eventId,
    eventData,
    eventReadOnlyTitle,
    formatDateTimeJST,
    formatYenText,
    getParticipantImageStyle,
    goContractDetail,
    groupedStageSeatingSummary,
    isEventCancelled,
    labelStatus,
    navigate,
    openCancelCompModal,
    stageSeatingSummary,
    stageSeatingSummaryLoading,
  } = view;

  return (
    <>
            {(canViewParticipants || canViewEventImages) ? (
            <div className="event-detail-card-grid event-detail-card-grid--resources">
            {canViewParticipants ? (
            <section className="event-panel stage-seating-summary-panel" id="stage-seating-section" data-section="stage-seating">
              <div className="panel-heading">
                <div>
                  <h3>ステージシーティング</h3>
                </div>
              </div>
              <div className="stage-seating-summary-body">
                {stageSeatingSummaryLoading ? (
                  <div className="stage-seating-summary-empty">
                    <ActionRowsSkeleton
                      rows={3}
                      containerClassName="stage-seating-summary-list"
                      itemClassName="stage-seating-summary-item"
                      mainClassName="stage-seating-summary-item-main"
                      actionsClassName="stage-seating-summary-item-actions"
                    />
                  </div>
                ) : stageSeatingSummary.layouts.length ? (
                  <div className="stage-seating-summary-list">
                    {groupedStageSeatingSummary.map((group) => (
                      <section className="stage-seating-summary-group" key={group.key}>
                        <div className="stage-seating-summary-group-head">
                          <span>{group.label}</span>
                          <small>{group.layouts.length}件</small>
                        </div>
                        <div className="stage-seating-summary-group-list">
                          {group.layouts.map((layout) => {
                            const shareLabels = Array.isArray(layout.share_targets)
                              ? layout.share_targets.map((share) => (share.share_scope === 'public' ? '全体公開' : `限定 ${share.artist_count || 0}`))
                              : [];
                            const detailLabel = layout.performance_name && layout.performance_name !== group.label
                              ? layout.performance_name
                              : '';
                            const openPreview = () => navigate(`/admin/workspaces/event-operations/events/${eventId}/stage-seating/preview?layout_id=${encodeURIComponent(layout.id)}`);
                            return (
                              <div
                                key={layout.id}
                                role="button"
                                tabIndex={0}
                                className="stage-seating-summary-item"
                                onClick={openPreview}
                                onKeyDown={(event) => {
                                  if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault();
                                    openPreview();
                                  }
                                }}
                              >
                                <span className="stage-seating-summary-item-main">
                                  <strong>{layout.title || '無題'}</strong>
                                  {detailLabel ? <small>{detailLabel}</small> : null}
                                </span>
                                <span className="stage-seating-summary-item-meta">
                                  <span>{Array.isArray(layout.placements) ? layout.placements.length : 0}人</span>
                                  {shareLabels.map((label) => <span key={label}>{label}</span>)}
                                  {canEditParticipants ? (
                                    <button
                                      type="button"
                                      className="stage-seating-summary-edit"
                                      onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        navigate(`/admin/workspaces/event-operations/events/${eventId}/stage-seating?layout_id=${encodeURIComponent(layout.id)}`);
                                      }}
                                      aria-label={`${layout.title || '無題'}を編集`}
                                      title="編集"
                                    >
                                      <i className="fa-solid fa-pen" aria-hidden="true"></i>
                                    </button>
                                  ) : null}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </section>
                    ))}
                    {stageSeatingSummary.layouts.length > 6 ? (
                      <div className="stage-seating-summary-more">ほか {stageSeatingSummary.layouts.length - 6} 件</div>
                    ) : null}
                  </div>
                ) : (
                  <p className="muted">
                    保存済みシーティングはまだありません。
                  </p>
                )}
                <div className="stage-seating-summary-actions">
                  {canEditParticipants ? (
                    <DsButton
                      type="button"
                      onClick={() => navigate(`/admin/workspaces/event-operations/events/${eventId}/stage-seating`)}
                    >
                      シーティングを作成
                    </DsButton>
                  ) : null}
                  <DsButton
                    type="button"
                    variant="secondary"
                    onClick={() => navigate(`/admin/workspaces/event-operations/events/${eventId}/stage-seating/preview`)}
                  >
                    プレビューを開く
                  </DsButton>
                </div>
              </div>
            </section>
            ) : null}

            {canViewEventImages ? (
            <section className="event-panel event-images-panel" id="event-images-section">
              <EventImageGallery
                eventUuid={eventId}
                eventName={eventData?.event_name || eventData?.name || eventData?.title || ''}
                eventDateLabel={eventData?.event_date ? formatDateTimeJST(eventData.event_date) : ''}
                canView={canViewEventImages}
                canUpload={canEditEventImages}
                canDownload={canDownloadEventImages}
              />
            </section>
            ) : null}
            </div>
            ) : null}

            {canViewMaterials ? (
            <section className="event-panel materials-panel" id="event-materials-section">
              <EventMaterialExplorer
                eventUuid={eventId}
                role="admin"
                title="イベント資料"
                canView={canViewMaterials}
                canUpload={canEditMaterials}
                canManage={canEditMaterials}
                canDownload={canDownloadMaterials}
                canViewAllLogs
                emptyLabel="登録された資料はありません"
              />
            </section>
            ) : null}

            {canViewContractStatus ? (
            <section className="event-panel contract-panel" id="event-contracts-section" aria-labelledby="event-contracts-heading">
              <div className="panel-heading">
                <div>
                  <h3 id="event-contracts-heading">契約状況</h3>
                </div>
              </div>
              <div className="contract-status-section">
                <div className="contract-status-summary">
                  <div className="contract-status-summary-card">
                    <span className="contract-status-summary-label">契約件数</span>
                    <strong className="contract-status-summary-value">{contractStatusSummary.totalContracts}</strong>
                  </div>
                  <div className="contract-status-summary-card">
                    <span className="contract-status-summary-label">対象アーティスト</span>
                    <strong className="contract-status-summary-value">{contractStatusSummary.uniqueArtists}</strong>
                  </div>
                  <div className="contract-status-summary-card">
                    <span className="contract-status-summary-label">マルチ契約</span>
                    <strong className="contract-status-summary-value">{contractStatusSummary.multiContracts}</strong>
                  </div>
                </div>
                {contractStatusSummary.statusItems.length > 0 ? (
                  <div className="contract-status-summary-statuses">
                    {contractStatusSummary.statusItems.map((item) => (
                      <span
                        key={item.status}
                        className={`contract-status-count ${
                          item.status === 'invoice_resubmission_pending'
                            ? 'status-pending'
                            : `status-${item.status}`
                        }`}
                      >
                        {item.label}: {item.count}
                      </span>
                    ))}
                  </div>
                ) : null}
                <div className="table-scroll">
                  <table className="contract-status-table">
                  <thead>
                    <tr>
                      <th>アーティスト</th>
                      <th>報酬内訳</th>
                      <th>契約ステータス</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contractTableRows.length === 0 ? (
                      <tr>
                        <td colSpan={3} className="muted">
                          契約送付済みのアーティストがいません。
                        </td>
                      </tr>
                    ) : (
                      contractTableRows.map((r) => {
                        const hasLink = !!r.contractDetailPath;
                        const updatedLabel = r.lastUpdatedAt ? formatDateTimeJST(r.lastUpdatedAt) : '—';

                        // ▼ 行クリック/フォーカス可能（行全体を一つのリンク扱い）
                        const rowProps = hasLink
                          ? {
                              className: 'clickable-row',
                              role: 'button',
                              tabIndex: 0,
                              onClick: (e) => goContractDetail(r.contractDetailPath, e),
                              onKeyDown: (e) => {
                                if (e.key === 'Enter' || e.key === ' ') goContractDetail(r.contractDetailPath, e);
                              },
                              title: '本契約の詳細を開く',
                            }
                          : {};

                        return (
                          <tr key={r.rowKey} {...rowProps}>
                            {/* アーティスト列：内部リンクは行クリックとバッティングしないよう停止 */}
                            <td>
                              <div className="artist-cell">
                                <div className="participant-profile-pic" style={getParticipantImageStyle(r)}>
                                  {!r.profile_picture && (r.artist_name || '').charAt(0)}
                                </div>
                                <div className="contract-artist-meta">
                                  <a
                                    className="artist-name-link"
                                    href={`/admin/workspaces/artist-management/artists/${r.artist_id}`}
                                    onClick={(e) => e.stopPropagation()}
                                    onKeyDown={(e) => e.stopPropagation()}
                                    aria-label="アーティスト詳細を開く（新規遷移）"
                                  >
                                    {r.artist_name}
                                  </a>
                                </div>
                              </div>
                            </td>

                            <td className="contract-reward-cell" data-label="報酬内訳">
                              {r.rewardLines.length > 0 ? (
                                <div className="contract-reward-lines">
                                  {r.rewardLines.map((line) => (
                                    <div
                                      key={line.key}
                                      className={`contract-reward-line${line.kind === 'supplemental' ? ' is-supplemental' : ''}`}
                                    >
                                      <span className="contract-reward-label">{line.label}：</span>
                                      <span className="contract-reward-value">{formatYenText(line.amount)}</span>
                                    </div>
                                  ))}
                                  <div className="contract-reward-total">
                                    <span>現在合計</span>
                                    <strong>{formatYenText(r.rewardTotal)}</strong>
                                  </div>
                                </div>
                              ) : (
                                <span className="contract-reward-empty">—</span>
                              )}
                            </td>

                            {/* 契約ステータス */}
                            <td data-label="契約ステータス">
                              <div className="contract-status-stack">
                                <div className="contract-status-badges">
                                  <span
                                    className={`status-badge ${
                                      r.invoice_resubmission_requested
                                        ? 'status-pending'
                                        : `status-${r.status}`
                                    }`}
                                  >
                                    {labelStatus(r.status, r)}
                                  </span>
                                  {r.isMulti ? <span className="contract-multi-badge">マルチ</span> : null}
                                </div>
                                <div className="contract-status-updated-text">最終更新: {updatedLabel}</div>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="panel-footer">
                <EventNavigationMenu event={{ event_uuid: eventId }} placement="detail" onlyCasting />
                {isEventCancelled ? (
                  <DsButton
                    type="button"
                    variant="secondary"
                    onClick={openCancelCompModal}
                    disabled={!canEditEventInfo || cancelCompSaving || cancelCompLoading}
                    title={!canEditEventInfo ? eventReadOnlyTitle : undefined}
                  >
                    {cancelCompLoading ? (
                      <SkeletonPill width={78} height={18} />
                    ) : (
                      '中止保証額を設定'
                    )}
                  </DsButton>
                ) : null}
              </div>
            </section>
            ) : null}
    </>
  );
}
